import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39206ad8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&id=39206ad8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39206ad8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AdHomepageTopAd: require('/usr/src/app/components/ad/homepage-top-ad.vue').default,IndexHomeData: require('/usr/src/app/components/index/home-data.vue').default,IndexRecommendArticle: require('/usr/src/app/components/index/recommend-article.vue').default,IndexTags: require('/usr/src/app/components/index/tags.vue').default,PublicChatroomSidebar: require('/usr/src/app/components/public/chatroom-sidebar.vue').default,PublicInfiniteDtb: require('/usr/src/app/components/public/infinite-dtb.vue').default,AdNavTopAd: require('/usr/src/app/components/ad/nav-top-ad.vue').default,IndexNews: require('/usr/src/app/components/index/news.vue').default,PublicOfficialAccounts: require('/usr/src/app/components/public/official-accounts/index.vue').default,AdNavBottomAd: require('/usr/src/app/components/ad/nav-bottom-ad.vue').default,ColumnHotColumn: require('/usr/src/app/components/column/hot-column.vue').default,PublicHotArticle: require('/usr/src/app/components/public/hot-article.vue').default})
